import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import './styles.css';
import { VotesProvider } from './context/VotesContext';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  // <React.StrictMode>
  <BrowserRouter>
    <VotesProvider>
      <App />
    </VotesProvider>
  </BrowserRouter>,
  // </React.StrictMode>
);
